import { ActorFilterOption } from '../../../swagger'

/**
 * Formats a ActorFilterOption into a specific string format.
 * Removes "Program Director" from the roleName if present.
 * @param {ActorFilterOption} actorOption - The director option to format.
 * @returns {string} - Formatted string in the format: name - roleName - (validFromYear - validToYear).
 */
export function formatActorOption(
  actorOption: ActorFilterOption | undefined | null
): string {
  if (!actorOption) return ''

  const { name, roleName, validFrom, validTo } = actorOption

  const validFromYear = validFrom.getFullYear()
  const validToYear = validTo.getFullYear()

  // Remove "Program Director" if present in the roleName
  const cleanedRoleName = roleName.replace(/^Program Director\s*/i, '')

  return `${name} / ${cleanedRoleName} / ${validFromYear} - ${validToYear}`
}
